"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _reactBootstrap = require("react-bootstrap");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

var _colors = require("../../config/colors");

var _QuestionsActions = require("../../redux/Questions/QuestionsActions");

var _config = require("../../config/config");

require("../../../css/CheckboxProperties.css");

require("../../../css/CommonProperties.css");

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable no-underscore-dangle */


var CheckboxProperties = function CheckboxProperties(_ref) {
  var question = _ref.question,
      updateCheckboxQuestion = _ref.updateCheckboxQuestion,
      errorMessages = _ref.errorMessages;
  var _window$pdfFormConfig = window.pdfFormConfigObject.field_types,
      radioField = _window$pdfFormConfig.radio_field,
      checkboxField = _window$pdfFormConfig.checkbox_field,
      _window$pdfFormConfig2 = _window$pdfFormConfig.multi_checkbox_field,
      multiCheckboxField = _window$pdfFormConfig2 === void 0 ? 27 : _window$pdfFormConfig2; // If this is true, we're in Onboarding and can show the multi-checkbox fields

  var multiCheckboxEnabled = window.pdfFormConfigObject.enableMultiCheckbox !== false;

  var _useState = (0, _react.useState)({
    selectionType: false,
    answers: false
  }),
      focusActive = _useState[0],
      setFocusActive = _useState[1]; // Track pending changes to ensure they're saved


  var pendingChangesRef = (0, _react.useRef)(new Map());
  var saveTimeoutRef = (0, _react.useRef)(null); // future refactor: make the test server remove _destroyed answers the way the real thing does so we can remove this filter

  var validAnswers = function validAnswers(answerAttributes) {
    return answerAttributes.filter(function (answer) {
      return answer._destroy !== true;
    }) || [];
  };

  var _useState2 = (0, _react.useState)(validAnswers(question.answers_attributes)),
      answers = _useState2[0],
      setAnswers = _useState2[1];

  (0, _react.useEffect)(function () {
    setAnswers(validAnswers(question.answers_attributes) || []);
  }, [question.answers_attributes]); // Cleanup effect to save pending changes when component unmounts or question changes

  (0, _react.useEffect)(function () {
    return function () {
      // Save any pending changes before cleanup
      if (pendingChangesRef.current.size > 0) {
        savePendingChanges();
      } // Clear timeout


      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, [question.id]); // Run cleanup when question changes
  // Also save pending changes when component unmounts

  (0, _react.useEffect)(function () {
    return function () {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, []); // Save pending changes to API

  var savePendingChanges = function savePendingChanges() {
    if (pendingChangesRef.current.size === 0) return; // Apply all pending changes to the current answers

    var updatedAnswers = [].concat(answers);
    pendingChangesRef.current.forEach(function (value, answerId) {
      updatedAnswers = updatedAnswers.map(function (answer) {
        if (answer.id === answerId) {
          return (0, _extends2["default"])({}, answer, {
            name: value,
            _destroy: false
          });
        }

        return answer;
      });
    });
    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: updatedAnswers
    }); // Clear pending changes

    pendingChangesRef.current.clear();
    updateCheckboxQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var onEditAnswer = function onEditAnswer(e) {
    var answerId = parseInt(e.target.getAttribute('answerid'), 10);
    var newValue = e.target.value; // Update local state immediately for UI responsiveness

    var updatedAnswers = answers.map(function (answer) {
      if (answer.id === answerId) {
        return (0, _extends2["default"])({}, answer, {
          name: newValue,
          _destroy: false
        });
      }

      return answer;
    });
    setAnswers(updatedAnswers); // Track this change as pending

    pendingChangesRef.current.set(answerId, newValue); // Clear any existing timeout and set a new one

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    } // Save changes after 1 second of inactivity


    saveTimeoutRef.current = setTimeout(function () {
      savePendingChanges();
    }, 1000);
  }; // Add a debounced save function to ensure changes are saved even if blur doesn't fire


  var saveAnswerChange = function saveAnswerChange(answerId, value) {
    var updatedAnswers = answers.map(function (answer) {
      if (answer.id === answerId) {
        return (0, _extends2["default"])({}, answer, {
          name: value,
          _destroy: false
        });
      }

      return answer;
    });
    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: updatedAnswers
    });
    updateCheckboxQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var onAnswerBlur = function onAnswerBlur(e) {
    var answerId = parseInt(e.target.getAttribute('answerid'), 10);
    var currentValue = e.target.value; // Clear the timeout since we're saving immediately

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
      saveTimeoutRef.current = null;
    } // Add this change to pending and save immediately


    pendingChangesRef.current.set(answerId, currentValue);
    savePendingChanges();
  };

  var onRemoveAnswer = function onRemoveAnswer(e) {
    // Prevent removing the last answer
    if (answers.length <= 1) {
      return;
    }

    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: answers.map(function (answer) {
        if (answer.id === parseInt(e.target.getAttribute('answerid'), 10)) {
          return (0, _extends2["default"])({}, answer, {
            _destroy: true
          });
        }

        return answer;
      })
    });
    updateCheckboxQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var onAddAnswer = function onAddAnswer() {
    var _question$data, _question$data2, _question$data3;

    var verticalSpacing = 5; // spacing between answers in percentage

    var lowestY = 0; // Default y-position
    // Find the lowest y-position among existing answers

    lowestY = Math.max.apply(Math, answers.map(function (answer) {
      var _answer$data;

      return (_answer$data = answer.data) !== null && _answer$data !== void 0 && _answer$data.pos ? answer.data.pos[1] : 0;
    })); // Create a base position if none exists

    var basePos = ((_question$data = question.data) === null || _question$data === void 0 ? void 0 : _question$data.pos) || [0, 0, 0, 0];
    var newAnswer = {
      name: "Option " + (answers.length + 1),
      position: answers.length + 1,
      _destroy: false,
      data: {
        pos: [basePos[0], lowestY + verticalSpacing, // place below the lowest answer
        basePos[2], basePos[3]],
        page: ((_question$data2 = question.data) === null || _question$data2 === void 0 ? void 0 : _question$data2.page) || 1,
        size: ((_question$data3 = question.data) === null || _question$data3 === void 0 ? void 0 : _question$data3.size) || 12,
        character_spacing: '0',
        align: 'left',
        overflow: 'shrink_to_fit'
      }
    };
    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: [].concat(answers, [newAnswer])
    });
    updateCheckboxQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var answerIsInvalid = function answerIsInvalid(answer) {
    if (errorMessages && !answer.name) {
      return true;
    }

    if (answer.name) {
      return false;
    }

    return true;
  };

  var handleSelectionTypeChange = function handleSelectionTypeChange(e) {
    var _question$answers_att; // Use multi_checkbox_field for "multiple" selection instead of regular checkbox
    // If multi_checkbox is disabled, fall back to regular checkbox
    // eslint-disable-next-line no-nested-ternary


    var newType = e.target.value === 'single' ? radioField : multiCheckboxEnabled ? multiCheckboxField : checkboxField; // Preserve existing answers when changing type

    var updatedQuestion = (0, _extends2["default"])({}, question, {
      question_type: newType,
      // Ensure we keep all answer data and IDs
      answers_attributes: ((_question$answers_att = question.answers_attributes) === null || _question$answers_att === void 0 ? void 0 : _question$answers_att.map(function (answer) {
        var _answer$data2, _question$data4, _answer$data3, _question$data5, _answer$data4, _question$data6, _answer$data5, _answer$data6, _answer$data7;

        return (0, _extends2["default"])({}, answer, {
          id: answer.id,
          name: answer.name,
          position: answer.position,
          data: (0, _extends2["default"])({}, answer.data || {}, {
            pos: ((_answer$data2 = answer.data) === null || _answer$data2 === void 0 ? void 0 : _answer$data2.pos) || ((_question$data4 = question.data) === null || _question$data4 === void 0 ? void 0 : _question$data4.pos) || [0, 0, 0, 0],
            page: ((_answer$data3 = answer.data) === null || _answer$data3 === void 0 ? void 0 : _answer$data3.page) || ((_question$data5 = question.data) === null || _question$data5 === void 0 ? void 0 : _question$data5.page) || 1,
            size: ((_answer$data4 = answer.data) === null || _answer$data4 === void 0 ? void 0 : _answer$data4.size) || ((_question$data6 = question.data) === null || _question$data6 === void 0 ? void 0 : _question$data6.size) || 12,
            character_spacing: ((_answer$data5 = answer.data) === null || _answer$data5 === void 0 ? void 0 : _answer$data5.character_spacing) || '0',
            align: ((_answer$data6 = answer.data) === null || _answer$data6 === void 0 ? void 0 : _answer$data6.align) || 'left',
            overflow: ((_answer$data7 = answer.data) === null || _answer$data7 === void 0 ? void 0 : _answer$data7.overflow) || 'shrink_to_fit'
          }),
          _destroy: answer._destroy || false
        });
      })) || []
    });
    updateCheckboxQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var isSingleSelect = question.question_type === radioField; // note we only show the answers and etc if we're in Onboarding - App gets Radio instead.

  return multiCheckboxEnabled &&
  /*#__PURE__*/
  _react["default"].createElement(_react["default"].Fragment, null,
  /*#__PURE__*/
  _react["default"].createElement("div", {
    className: "mt-2"
  },
  /*#__PURE__*/
  _react["default"].createElement(_reactBootstrap.Form.Label, {
    className: "form-label"
  }, "Selection Type"),
  /*#__PURE__*/
  _react["default"].createElement(_reactBootstrap.Form.Control, {
    as: "select",
    name: "selectionType",
    className: "form-control " + (focusActive.selectionType ? 'focused-input' : ''),
    value: isSingleSelect ? 'single' : 'multiple',
    onChange: handleSelectionTypeChange,
    onFocus: function onFocus() {
      return setFocusActive((0, _extends2["default"])({}, focusActive, {
        selectionType: true
      }));
    },
    onBlur: function onBlur() {
      return setFocusActive((0, _extends2["default"])({}, focusActive, {
        selectionType: false
      }));
    },
    style: {
      backgroundColor: _colors.SIDEBAR_INPUTS_BACKGROUND_COLOR,
      margin: _config.SIDEBAR_INPUTS_MARGIN
    },
    "data-cy": "selection-type-select"
  },
  /*#__PURE__*/
  _react["default"].createElement("option", {
    value: "multiple"
  }, "Multiple Selection (Checkbox)"),
  /*#__PURE__*/
  _react["default"].createElement("option", {
    value: "single"
  }, "Single Selection (Radio)"))),
  /*#__PURE__*/
  _react["default"].createElement("h6", {
    className: "font-weight-bold mt-2"
  }, "Answers"),
  /*#__PURE__*/
  _react["default"].createElement("div", {
    className: "mb-3"
  }, answers.map(function (answer, i) {
    return (
      /*#__PURE__*/
      _react["default"].createElement(_react.Fragment, {
        key: answer.id
      },
      /*#__PURE__*/
      _react["default"].createElement(_reactBootstrap.InputGroup, {
        className: "mb-2"
      },
      /*#__PURE__*/
      _react["default"].createElement(_reactBootstrap.FormControl, {
        "aria-label": "Radio Option",
        placeholder: "Option " + (i + 1),
        "aria-describedby": "option-addon",
        className: "form-input",
        id: "btnChoiceOption" + i,
        answerid: answer.id,
        onFocus: function onFocus() {},
        onBlur: onAnswerBlur,
        name: "answers",
        onChange: onEditAnswer,
        onKeyDown: function onKeyDown(e) {
          // Save on Enter key as backup
          if (e.key === 'Enter') {
            var answerId = parseInt(e.target.getAttribute('answerid'), 10);
            saveAnswerChange(answerId, e.target.value);
          }
        },
        isInvalid: answerIsInvalid(answer),
        value: answer.name || ''
      }), answers.length > 1 &&
      /*#__PURE__*/
      _react["default"].createElement(_reactBootstrap.InputGroup.Append, null,
      /*#__PURE__*/
      _react["default"].createElement(_reactBootstrap.Button, {
        answerid: answer.id,
        onClick: onRemoveAnswer,
        variant: "light",
        className: "remove-option-button",
        style: {
          backgroundColor: 'white',
          border: '1px solid lightgray',
          borderLeft: 'none'
        }
      },
      /*#__PURE__*/
      _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        answerid: answer.id,
        icon: _proLightSvgIcons.faTimesCircle,
        className: "text-dark",
        onClick: onRemoveAnswer
      }))),
      /*#__PURE__*/
      _react["default"].createElement(_reactBootstrap.Form.Control.Feedback, {
        type: "invalid",
        className: "text-right"
      }, _config.CHECKBOX_OPTION_NAME_FEEDBACK)))
    );
  }),
  /*#__PURE__*/
  _react["default"].createElement("div", {
    className: "text-center"
  },
  /*#__PURE__*/
  _react["default"].createElement(_reactBootstrap.Button, {
    id: "btnAddAnswer",
    variant: "outline-primary",
    className: "w-50 my-2",
    onClick: onAddAnswer
  }, ' ', "+ Add Answer"))));
};

CheckboxProperties.propTypes = process.env.NODE_ENV !== "production" ? {
  question: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    // eslint-disable-next-line react/forbid-prop-types
    data: _propTypes["default"].object,
    question_type: _propTypes["default"].number,
    id: _propTypes["default"].number,
    // eslint-disable-next-line react/forbid-prop-types
    answers_attributes: _propTypes["default"].array,
    // eslint-disable-next-line react/forbid-prop-types
    answers: _propTypes["default"].array
  }).isRequired,
  updateCheckboxQuestion: _propTypes["default"].func.isRequired,
  errorMessages: _propTypes["default"].bool
} : {};
CheckboxProperties.defaultProps = {
  errorMessages: false
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateCheckboxQuestion: function updateCheckboxQuestion(question, lastSave) {
      return dispatch((0, _QuestionsActions.waitApiUpdateQuestion)(question, lastSave));
    }
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(CheckboxProperties);